import Token from '@/utils/Token';

export default {
    meus() {
        return axios.get('/api/tenant-ativo', Token.getHeader());
    },
    trocar(tenantId, padrao) {
        return axios.patch('/api/tenant-ativo', { tenant_id: tenantId, padrao }, Token.getHeader());
    },
}
